import { useRef, useState } from 'react';

export function FileInput({ onFile, accept, label = 'Upload file', hint }) {
  const inputRef = useRef(null);
  const [over, setOver] = useState(false);
  const [selected, setSelected] = useState(null);

  const handle = (file) => {
    if (!file) return;
    setSelected(file);
    onFile(file);
  };

  return (
    <div>
      <div
        className={`file-drop-zone${over ? ' over' : ''}`}
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setOver(true); }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setOver(false);
          handle(e.dataTransfer.files[0]);
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') inputRef.current?.click(); }}
        aria-label={label}
      >
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          onChange={(e) => handle(e.target.files[0])}
          tabIndex={-1}
        />
        {selected ? (
          <p style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--weight-medium)' }}>
            ✓ {selected.name} ({Math.round(selected.size / 1024)} KB)
          </p>
        ) : (
          <>
            <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
              {label}
            </p>
            {hint && <p style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-subtle)', marginTop: 4 }}>{hint}</p>}
          </>
        )}
      </div>
    </div>
  );
}
